<div
  *ngIf="operatingMode?.properties?.value?.value || isDhw"
  class="mode-icon flex flex-row justify-center items-center"
>
  <ng-container *ngIf="isDhw; else operatingModeIcon">
    <vi-icon
      [name]="dhwOperatingModeName | iconOperatingMode"
      [matTooltip]="dhwOperatingModeName | translateOperatingMode"
      [size]="18"
    ></vi-icon>
  </ng-container>
  <ng-template #operatingModeIcon>
    <vi-icon
      [name]="operatingMode.properties.value.value | iconOperatingMode"
      [matTooltip]="operatingMode.properties.value.value | translateOperatingMode"
      [size]="18"
    ></vi-icon>
  </ng-template>
</div>
